export default "__VITE_ASSET__D_QIZKF0__"